import { ThunkAction } from 'redux-thunk';

import { SearchConditions, SearchResult, search } from '../services/contractApi';
export { SearchConditions, SearchResult, UpdateConditions } from '../services/contractApi';

export type SearchContentsState = 'none' | 'searching';
export const statusPatterns = { 10: '申請中', 20: '確定' };
export const defaultPerPage = 25;

/**
 * 検索用モジュール
 */
export interface SearchState {
  search: SearchResult | null;
  searchState: SearchContentsState;
  searchMessages: string[];
  statusS: number;
}

const initialState: SearchState = {
  search: null,
  searchState: 'none',
  searchMessages: [],
  statusS: 0,
};

const REQUEST_SEARCH = 'REQUEST_SEARCH';
type REQUEST_SEARCH = typeof REQUEST_SEARCH;

const RECEIVE_SEARCH = 'RECEIVE_SEARCH';
type RECEIVE_SEARCH = typeof RECEIVE_SEARCH;

const FAIL_SEARCH = 'FAIL_SEARCH';
type FAIL_SEARCH = typeof FAIL_SEARCH;

const CLEAR_SEARCH = 'CLEAR_SEARCH';
type CLEAR_SEARCH = typeof CLEAR_SEARCH;

const CLEAR_SEARCH_MESSAGES = 'CLEAR_SEARCH_MESSAGES';
type CLEAR_SEARCH_MESSAGES = typeof CLEAR_SEARCH_MESSAGES;

interface RequestSearch {
  type: REQUEST_SEARCH;
}

interface ReceiveSearch {
  type: RECEIVE_SEARCH;
  search: SearchResult;
}

interface FailSearch {
  type: FAIL_SEARCH;
  messages: string[];
  status: number;
}

interface ClearSearch {
  type: CLEAR_SEARCH;
}

interface ClearSearchMessages {
  type: CLEAR_SEARCH_MESSAGES;
}

export type SearchAction = RequestSearch | ReceiveSearch |
  FailSearch | ClearSearch | ClearSearchMessages;

type SearchDocuments =
  ThunkAction<void, SearchState, undefined, SearchAction>;

export function requestSearch(): RequestSearch {
  return {
    type: REQUEST_SEARCH,
  };
}

export function receiveSearch(search: SearchResult): ReceiveSearch {
  return {
    search,
    type: RECEIVE_SEARCH,
  };
}

export function failSearch(messages: string[], status: number): FailSearch {
  return {
    messages,
    status,
    type: FAIL_SEARCH,
  };
}

export function clearSearch(): ClearSearch {
  return {
    type: CLEAR_SEARCH,
  };
}

export function clearSearchMessages(): ClearSearchMessages {
  return {
    type: CLEAR_SEARCH_MESSAGES,
  };
}

export function searchDocuments(conditions: SearchConditions): SearchDocuments {
  return (dispatch) => {
    dispatch(requestSearch());
    // 検索API呼び出し
    return search(conditions).then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(receiveSearch(result));
      } else {
        dispatch(failSearch(messages, status_code));
      }
    }).catch((err) => {
      dispatch(failSearch([String(err)], 500));
    });
  };
}

export default function reducer(
  state: SearchState | undefined,
  action: SearchAction,
): SearchState {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_SEARCH: {
      return { ...state, searchState: 'searching' };
    }
    case RECEIVE_SEARCH: {
      const { search  } = action;
      return { search, searchState: 'none', searchMessages: [], statusS: 200 };
    }
    case FAIL_SEARCH: {
      const { messages, status } = action;
      return { ...state, statusS: status, searchState: 'none', searchMessages: messages };
    }
    case CLEAR_SEARCH: {
      return initialState;
    }
    case CLEAR_SEARCH_MESSAGES: {
      return { ...state, searchMessages: [] };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/search.ts